import { render, staticRenderFns } from "./adminLandingTerms.vue?vue&type=template&id=2401b993"
import script from "./adminLandingTerms.vue?vue&type=script&lang=js"
export * from "./adminLandingTerms.vue?vue&type=script&lang=js"
import style0 from "./adminLandingTerms.vue?vue&type=style&index=0&id=2401b993&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports